
import storeCode from '~/mixins/storeCode'
import productReview from '~/mixins/productReview'

export default {
  name: 'ProductPhysicalTitle',
  mixins: [
    storeCode,
    productReview,
  ],

  props: {
    name: {
      type: String,
      default: '',
    },

    desc: {
      type: String,
      default: '',
    },
  },

  data () {
    return {
      isExpanded: false,
    }
  },

  computed: {
    shouldShowMoreButtonOnDesktop () {
      const plainText = this.desc.replace(/<[^>]*>?/gm, '')

      return plainText.length > 204 // 204 characters for 3 lines
    },

    shouldShowMoreButtonOnMobile () {
      const plainText = this.desc.replace(/<[^>]*>?/gm, '')

      return plainText.length > 156 // 156 characters for 3 lines
    },
  },

  methods: {
    toggleExpand () {
      this.isExpanded = !this.isExpanded
    },
  },
}
